import { replace, useClasses, useClassesMapper, ClassesMapper } from '@xo-union/react-css-modules';
import Icon from '@xo-union/tk-component-icons';
import Spinner from '@xo-union/tk-component-spinner';
import React from 'react';
import { match, useHistory } from 'react-router-dom';

import { ShareValues } from '../../SharePage/SmsSequence';
import useShareTracking from '../../SharePage/useShareTracking';
import PreviewOverlay from './PreviewOverlay';
import { SmsBubble } from './SmsBubble';
import styles from './smsPreview.scss';

interface Props {
  match: match<{}> | null;
  editRoute?: string;
  loading: boolean;
  smsLink?: string;
  values: ShareValues;
  classes?: ClassesMapper<string>;
  onClick?: () => void;
}

export const SmsPreview: React.FC<Props> = ({
  match,
  editRoute = '',
  onClick,
  loading,
  smsLink,
  values,
  classes: classesProp,
}) => {
  const history = useHistory();
  const track = useShareTracking();
  // @ts-ignore
  const classes = useClasses(styles, classesProp);
  const classForNestedComponent = useClassesMapper(
    replace({
      previewFrame: styles.previewFrame,
      bodyContainer: styles.bodyContainer,
    }),
    // @ts-ignore
    classesProp
  );

  const editMessage = () => {
    if (onClick) {
      onClick();
    } else {
      track('WWS Share Interaction', { action: 'edit message initiated' });
      history.push(editRoute);
    }
  };

  return (
    <PreviewOverlay messageType="SMS" onClick={editMessage} match={match} classes={classForNestedComponent}>
      <div className={classes.smsHeader}>
        <Icon name="caret_left" size="md" className={classes.backArrow} />
        <div className={classes.title}>The Knot</div>
        <span>55555</span>
      </div>
      <div className={classes.smsBody}>
        {loading ? (
          <Spinner />
        ) : (
          <>
            <SmsBubble message={values.greeting ? values.greeting : ''} />
            <SmsBubble message={values.message} />
            {smsLink ? <SmsBubble message={smsLink} /> : null}
            <SmsBubble message={values.optout ? values.optout : ''} />
          </>
        )}
      </div>
      <div className={classes.composeBar}>
        <div className={classes.composeBubble}>
          <Icon name="caret_right" size="md" />
        </div>
      </div>
    </PreviewOverlay>
  );
};
